import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import { insh, sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import LoadingPage from "../../../../services/LoadingPage";
import Restriction from "./Restriction";
import { Dialog } from "@material-ui/core";
import { useTranslation } from "react-i18next";
const defaultAutos = {
    Branches: [],
};

export default function RestrictionDailogCon(props) {
    const { open, onClose, onSave, invData } = props;
    const { t } = useTranslation(["forms"]);

    const [branch, setBranch] = useState({ id: -1, name: t("all") });
    const tttb = {
        wait: true,
        other: true,
        costcenters: true,
        branches: true,
        omlat: true,
        UsersA: true,
        // UsersAll: true,
        AccountBooks: true,
        PermissionsElemnts: true,
        stor: { ...sto, branchi: branch.id == -1 ? sto.branchi : branch.id },

        parms: {
            ibranchid: invData.branch,
            iempid: sto.empi,
            iuserid: sto.idi,
            branch: invData.branch,
            tname: "drest",
            withOmlat: true,
            iformid: "60002",
        },
        autos: {
            branches: true,
            costcenters: true,
            AccountBooks: true,
            omlat: true,
        },
    };


    const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
        uri + "Res",
        tttb,
        [branch]
    );

    const tb2 = {
        wait: true,
        AccountsIndex: true,
        UsersAll:true,
        stor: sto,
        parms: {
            iempid: sto.empi,
            branch: sto.branchi,
        },
    };

    const { object: Accounts } = useFetchObjectByPost(
        uri + "GetD",
        tb2,
    );


    if (
        fetchAll ||
        !Accounts ||
        !AutoOptions?.Branches ||
        !AutoOptions?.costcenters
    )
        return <LoadingPage />;

    return (
        <Dialog fullScreen open={open} onClose={onClose}>
            <Restriction
                {...{
                    AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
                    branch,
                    setBranch,
                    prmis: AutoOptions?.permisElm?? insh.permiElm, 
                    IsOpen: false,
                    isDialog: false,
                    isDialogData: true,
                    Accounts,
                    invData,
                    onClose,
                    onSave
                }}
            />
        </Dialog>

    );
}
